import { useTranslation } from 'react-i18next'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerHeader,
	DrawerTitle,
} from '@/components/ui/drawer'
import { useScreenWakeLock } from '@/hooks/use-screen-wake-lock'
import { useDeviceType } from '@/hooks/useDeviceType'
import { useVirtualBadgeStore } from '@/store'
import { VirtualBadgeCard } from './virtual-badge-card'

export const VirtualBadgeModal = () => {
	const { t } = useTranslation()
	const { isMobile } = useDeviceType()
	const { isOpen, setOpen } = useVirtualBadgeStore()

	useScreenWakeLock(isOpen)

	if (isMobile) {
		return (
			<Drawer onOpenChange={setOpen} open={isOpen}>
				<DrawerContent className="max-h-[95vh]">
					<DrawerHeader className="pb-2">
						<DrawerTitle>{t('virtualBadge.title')}</DrawerTitle>
						<DrawerDescription>
							{t('virtualBadge.description')}
						</DrawerDescription>
					</DrawerHeader>
					<div className="overflow-y-auto px-4 pb-6">
						<VirtualBadgeCard enabled={isOpen} />
					</div>
				</DrawerContent>
			</Drawer>
		)
	}

	return (
		<Dialog onOpenChange={setOpen} open={isOpen}>
			<DialogContent className="sm:max-w-sm">
				<DialogHeader>
					<DialogTitle>{t('virtualBadge.title')}</DialogTitle>
					<DialogDescription>{t('virtualBadge.description')}</DialogDescription>
				</DialogHeader>
				<VirtualBadgeCard enabled={isOpen} />
			</DialogContent>
		</Dialog>
	)
}
